/*
 * @Author: ziqi.tang 3483153081@qq.com
 * @Date: 2025-09-14 10:03:24
 * @LastEditors: ziqi.tang 3483153081@qq.com
 * @LastEditTime: 2025-10-18 11:57:37
 * @FilePath: \git\xht-web-business\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * API请求工具
 * 基于axios封装，支持不同环境的API地址
 */
import axios from 'axios'
import config from '@/config'
import store from '@/store'

// 从环境变量获取后端服务IP，默认为 localhost
const API_HOST = process.env.VUE_APP_API_HOST || 'localhost'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_ENV === 'production' ? 'https://api.xihuiting.com' : (process.env.VUE_APP_ENV === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8080`),
  timeout: config.apiTimeout || 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 根据URL动态设置baseURL
    const url = config.url || ''
    const env = process.env.VUE_APP_ENV || process.env.NODE_ENV || 'development'
    
    // 根据URL前缀设置不同的baseURL
    if (url.startsWith('/uic')) {
      config.baseURL = env === 'production' ? 'https://api.xihuiting.com' : (env === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8080`)
    } else if (url.startsWith('/road')) {
      config.baseURL = env === 'production' ? 'https://api.xihuiting.com' : (env === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8081`)
    } else if (url.startsWith('/order')) {
      config.baseURL = env === 'production' ? 'https://api.xihuiting.com' : (env === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8086`)
    } else if (url.startsWith('/market')) {
      config.baseURL = env === 'production' ? 'https://api.xihuiting.com' : (env === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8100`)
    } else if (url.startsWith('/parking')) {
      config.baseURL = env === 'production' ? 'https://api.xihuiting.com' : (env === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8110`)
    } else if (url.startsWith('/payment') || url.startsWith('/pay')) {
      config.baseURL = env === 'production' ? 'https://api.xihuiting.com' : (env === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8090`)
    } else if (url.startsWith('/invoice')) {
      config.baseURL = env === 'production' ? 'https://api.xihuiting.com' : (env === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8108`)
    } else {
      // 默认使用 uic 服务
      config.baseURL = env === 'production' ? 'https://api.xihuiting.com' : (env === 'staging' ? 'https://testapi.xihuiting.com' : `http://${API_HOST}:8080`)
    }
    
    // 在发送请求之前做些什么
    // 优先从Vuex store获取token，如果没有则从localStorage获取
    // 这样可以避免某些情况下localStorage未同步成功的问题
    const storeToken = store.getters.token
    const localStorageToken = window.localStorage.getItem('token')
    const raw = storeToken || localStorageToken
    
    if (raw) {
      // 规范化token：去首尾空白、去包裹引号、移除所有空白字符，并移除任何已有的 Bearer 前缀
      let token = String(raw).trim().replace(/^"|"$/g, '').replace(/\s+/g, '')
      token = token.replace(/^Bearer(\s)*/i, '')
      const bearer = `Bearer ${token}`
      config.headers.Authorization = bearer
      // 兼容某些服务对大小写敏感的实现
      config.headers.authorization = bearer
      
      // 如果store中有token但localStorage中没有，同步到localStorage
      if (storeToken && !localStorageToken) {
        try {
          window.localStorage.setItem('token', storeToken)
        } catch (e) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('[auth] 同步token到localStorage失败:', e)
          }
        }
      }
      
      if (process.env.NODE_ENV === 'development') {
        // 仅打印部分以免泄露
        const preview = token.slice(0, 12) + '...' + token.slice(-8)
        const source = storeToken ? 'store' : 'localStorage'
        console.log(`[auth] attach Authorization header from ${source}:`, 'Bearer ' + preview)
      }
    }
    
    // 开发环境打印请求信息
    if (process.env.NODE_ENV === 'development') {
      console.log('请求配置:', {
        url: config.url,
        method: config.method,
        baseURL: config.baseURL,
        headers: config.headers
      })
    }
    
    return config
  },
  error => {
    // 对请求错误做些什么
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    if (process.env.NODE_ENV === 'development') {
      console.log('响应数据:', response.data)
    }
    
    // 检查服务端返回的业务错误码
    const data = response.data
    if (data && typeof data === 'object' && 'code' in data) {
      // 如果 code 不是 200，说明业务逻辑失败，应该抛出异常
      if (data.code !== 200 && data.code !== 0) {
        const error = new Error(data.message || data.error || '请求失败')
        error.response = {
          ...response,
          data: data
        }
        error.code = data.code
        return Promise.reject(error)
      }
    }
    
    return response.data
  },
  error => {
    // 对响应错误做点什么
    console.error('响应错误:', error)
    const status = error?.response?.status
    if (status === 401) {
      // 不再自动清空 token，避免其它接口偶发 401 导致后续全部失效
      // 仅做一次性重定向到登录页（5秒内去抖）
      try {
        const key = 'auth_redirect_ts'
        const last = Number(sessionStorage.getItem(key) || 0)
        const now = Date.now()
        if (now - last > 5000 && window.location && !/\/login(\?|$)/.test(window.location.pathname)) {
          sessionStorage.setItem(key, String(now))
          const from = encodeURIComponent(window.location.pathname + window.location.search)
          window.location.href = `/login?from=${from}`
        }
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.warn('401 重定向去抖处理异常:', e)
        }
      }
    } else if (status === 403) {
      // 403 Forbidden：权限不足
      // 增强错误信息，提供更友好的提示
      const errorMessage = error?.response?.data?.message || 
                          error?.response?.data?.error || 
                          '权限不足，无法执行此操作'
      error.message = errorMessage
      error.statusCode = 403
      if (process.env.NODE_ENV === 'development') {
        console.warn('[403] 权限不足:', {
          url: error?.config?.url,
          method: error?.config?.method,
          message: errorMessage
        })
      }
    }
    return Promise.reject(error)
  }
)

export default request
